import { Component } from '@angular/core';

import { Icon } from '../../components/redesign/icon/models/icon.model';
import { ListItem } from '../../components/redesign/list/models/list-item.model';
import { TextAlignment } from '../../components/redesign/title/models/text-alignment.enum';

@Component({
	templateUrl: './demo.page.html',
	styleUrls: ['./demo.page.scss'],
})
export class DemoPage {
	textAlignment = TextAlignment;
	icon: Icon = {
		fontSize: 24,
		name: 'fas fa-yin-yang',
	};

	image: Icon = {
		image: {
			url: 'assets/icon/ic_product.svg',
			height: '48px',
			width: '48px',
		},
	};

	listItem: ListItem[] = [
		{
			icon: {
				name: 'far fa-eye',
				fontSize: 24,
				backgroundColor: null,
			},
			title: 'title',
			highlightText: 'highlightText',
			subtitle: 'subtitle',
			actionIcon: 'link',
			action: () => alert('list item clicked'),
		},
		{
			icon: {
				name: 'far fa-eye',
				fontSize: 24,
				backgroundColor: null,
			},
			title: 'title',
			highlightText: 'highlightText',
			subtitle: 'subtitle',
			actionIcon: 'link',
			action: () => alert('list item clicked'),
		},
		{
			icon: {
				name: 'far fa-eye',
				fontSize: 24,
				backgroundColor: null,
			},
			title: 'title',
			highlightText: 'highlightText',
			subtitle: 'subtitle',
			actionIcon: 'link',
			action: () => alert('list item clicked'),
		},
	];

	actionButtonClicked() {
		alert('button clicked');
	}

	higherOrderFunction(text: string) {
		return () => alert(`higher order function (text=${text})`);
	}
}
